export class PaymentPageCurrency {
    id: number;
    symbol:string;
    isLinkageCurrency:boolean;
}
